import { IContainerStrategy } from '../ContainerStrategy'
import {
    ContainerDataType,
    ContainerType,
    TaskMode,
    AgenticAnnotationDataType,
    AttributeDefinitionType,
    AttributesData,
    QCAttributesData,
    TaskConfigType,
    ValueDataType,
} from 'Types/Tasks.types'
import { cloneDeep } from 'lodash'
import { isViewerMode } from 'Utils/task.utils'
import { AgenticAnnotationTask } from 'Tasks/AgenticAnnotation/AgenticAnnotationTask'

export class AgenticAnnotationContainerStrategy
    implements IContainerStrategy<ContainerType.AgenticAnnotation, AgenticAnnotationDataType>
{
    containerContext?: {
        task: AgenticAnnotationTask
    }

    setContext(containerContext: { task: AgenticAnnotationTask }) {
        this.containerContext = containerContext
    }

    getEmptyDraftContainer(): ContainerDataType<
        ContainerType.AgenticAnnotation,
        AgenticAnnotationDataType
    > {
        return {
            data: {
                schema_version: 1,
                type: ContainerType.AgenticAnnotation,
                data: {
                    response: {
                        id: crypto.randomUUID(),
                        extra_info: {},
                        version_id: null,
                        is_complete: false,
                        tool_meta_data: [],
                    },
                    quality_check: {
                        evaluation_on_response_version_id: {},
                    },
                },
            },
        }
    }

    getContainerFromOutputStart(
        outputStartContainer: ContainerDataType<
            ContainerType.AgenticAnnotation,
            AgenticAnnotationDataType
        >,
        mode: TaskMode
    ): ContainerDataType<ContainerType.AgenticAnnotation, AgenticAnnotationDataType> {
        const draftContainer = cloneDeep(outputStartContainer)

        if (draftContainer && !isViewerMode(mode)) {
            draftContainer.data.data.quality_check.evaluation_on_response_version_id = {}
            draftContainer.decision = null
        }

        return draftContainer
    }

    getModifiedDraftOutputContainer = (
        draftOutputContainer: ContainerDataType<
            ContainerType.AgenticAnnotation,
            AgenticAnnotationDataType
        >,
        taskConfig: TaskConfigType<ContainerType.AgenticAnnotation, AgenticAnnotationDataType>
    ) => {
        const draftContainer = cloneDeep(draftOutputContainer)

        const extraInfo: AttributesData = {}
        const qcAttributes: { [versionId: string]: QCAttributesData } = {}

        if (!draftContainer) {
            return draftContainer
        }

        const versionIds = Object.keys(
            draftContainer.data.data.quality_check.evaluation_on_response_version_id ?? {}
        )

        taskConfig.assignment.task.attributes.forEach(attribute => {
            if (
                draftContainer.data.data.response.extra_info?.[attribute.name] &&
                attribute.type === AttributeDefinitionType.EXTRA_INFO
            ) {
                extraInfo[attribute.name] = draftContainer.data.data.response.extra_info?.[
                    attribute.name
                ] as ValueDataType<never>
            }

            versionIds.forEach(versionId => {
                if (
                    draftContainer.data.data.quality_check.evaluation_on_response_version_id?.[
                        versionId
                    ]?.[attribute.name] &&
                    attribute.type === AttributeDefinitionType.QUALITY_EVALUATION
                ) {
                    qcAttributes[versionId] = {
                        ...qcAttributes[versionId],
                        [attribute.name]:
                            draftContainer.data.data.quality_check
                                .evaluation_on_response_version_id[versionId][attribute.name],
                    } as QCAttributesData
                }
            })
        })
        draftContainer.data.data.response.extra_info = extraInfo
        draftContainer.data.data.quality_check.evaluation_on_response_version_id = qcAttributes

        return draftContainer
    }
}
